import * as actionTypes from './actionTypes';
import axios from '../../axios';
import logger from '../../logger';

export const updateAuthToken = (callback) => {
    return dispatch => {
        // Session auth handled by cookies - no token fetch needed
        if (callback) {
            callback();
        }
    }
}



export const fetchUsersSuccess = (details) => {
    return {
        type: actionTypes.FETCH_USERS_SUCCESS,
        users: details
    }
};

export const fetchUsersFailure = (error) => {
    return {
        type: actionTypes.FETCH_USERS_FAILURE,
        error: error
    };
};

export const fetchUsersStart = () => {
    return {
        type: actionTypes.FETCH_USERS_START
    }
};

export const fetchUsers = () => {
    return dispatch => {
        dispatch(fetchUsersStart());
        
        axios.get('/users.json')
        .then(res => {
            const fetchedUsers = [];
            for (let key in res.data) {
                let imageUrl = (res.data[key].user.photo_url ? res.data[key].user.photo_url : "https://worshipkit.s3.amazonaws.com/assets/img/standin_profile.png");
                fetchedUsers.push({
                    ...res.data[key],
                    link: '/users/' + res.data[key].user.id,
                    icon: imageUrl,
                    name: res.data[key].user.first_name + " " + res.data[key].user.last_name
                });
                logger.log(JSON.stringify(fetchedUsers));
            }
            dispatch(fetchUsersSuccess(fetchedUsers));
        })
        .catch(err => {
            dispatch(fetchUsersFailure(err));
            alert(err.message);
        });
        
    }
}
